import { Box, Grid, Card, Typography, Menu, MenuItem, IconButton } from '@mui/material';
import UserAvatarComponent from 'components/UserAvatarComponent';
import { convertDateAndTime, processToUpper } from 'Helpers';
import ThreeDot from '../../assets/static_images/threedot.svg';
import { useState } from 'react';
const NewsHeader = ({ news, openOption, setOpenOption, setOpenEditor, setOpenDeleteModal, canEdit, canDelete }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    console.log('news header', news);

    return (
        <Box display="flex" alignItems="center" sx={{ position: 'relative' }}>
            <UserAvatarComponent userData={news.user} />
            <Box sx={{ marginLeft: '1rem' }} flex="1">
                <Typography variant="h6">{`${news?.user?.first_name} ${news?.user?.last_name}`}</Typography>
                <Box display="flex" gap="0.5rem">
                    <Typography sx={{ fontSize: '14px', opacity: '0.5' }}>{news.user?.job_title[0]?.title ?? 'N/A'}</Typography>
                </Box>
            </Box>
            <Typography variant="subtitle1" sx={{ opacity: '0.5', fontSize: '14px', mr: 1 }}>
                {convertDateAndTime(news.createdAt)}
            </Typography>
            {JSON.parse(window.localStorage.getItem('authUser'))?.user_id == news.user_id && canEdit && (
                <IconButton
                    onClick={handleClick}
                    size="small"
                    aria-controls={open ? 'news-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? 'true' : undefined}
                >
                    <img src={ThreeDot} alt="dot" />
                </IconButton>
            )}
            <Menu
                id="news-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button'
                }}
            >
                {canEdit && (
                    <MenuItem
                        onClick={() => {
                            handleClose();
                            setOpenEditor(true);
                        }}
                    >
                        Edit
                    </MenuItem>
                )}
                {canDelete && (
                    <MenuItem
                        onClick={() => {
                            handleClose();
                            setOpenDeleteModal(true);
                        }}
                    >
                        Delete
                    </MenuItem>
                )}
            </Menu>
        </Box>
    );
};

export default NewsHeader;
